import React, { useEffect, useRef, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { BsEmojiSmile } from "react-icons/bs";
// import Picker from 'emoji-picker-react';
import BarLoader from "react-spinners/BarLoader";
import MoonLoader from "react-spinners/MoonLoader";
import './Chat.scss'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Message from '../Message/Message';
import { BiMessage, BiSupport } from "react-icons/bi";
import { GrFormClose } from "react-icons/gr";
import { SocketContext } from '../../contexts/SocketContextProvider';
import { socket } from '../../utils';
import { callBBCard } from '../../services';
import { setPage } from '../../redux/actions/commonActions';
import { FiSend, FiPaperclip } from "react-icons/fi";
import {axios} from '../../utils'
import { ReactNotifications, Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
// import { Picker } from 'emoji-mart'
// import 'emoji-mart/css/emoji-mart.css';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'


const WAITING_FOR_AGENT ='WAITING_FOR_AGENT'
const PARTICIPANT_ADDED ='PARTICIPANT_ADDED'
const PARTICIPANT_DISCONNECTED ='PARTICIPANT_DISCONNECTED'
const SOCKET_DISCONNECTED ='SOCKET_DISCONNECTED'
const SUPERVISOR ='SUPERVISOR'
const AGENT ='AGENT'
const SYSTEM_CONNECTED = 'SYSTEM_CONNECTED'

const CUSTOMER='CUSTOMER'


function Chat({mParam}) {

    const [msg ,setMsg ] = useState('')
    const [isEmojiShown ,setIsEmojiShown ] = useState(false)
    const [chatConnectivityStatus , setChatConnectivityStatus] = useState(WAITING_FOR_AGENT)
    const [responderType , setResponderType] = useState('')
    const [agentDispalyName , setAgentDispalyName] = useState('')
    const [disableChat, setDisableChat] = useState("disabled"); // TBD in future if we want disable feature
    const textarea = useRef(null)
    const pickerRef = useRef(null);

    const { engagement, user, ui, common } = useSelector(state=>state);
    const config = ui?.config?.attributes;

    // console.log('CONFIG', config);

    let isMounted = true;
    const scrollRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { messages, participants, isSocketConnected, isBotConnected, engagementParam } = useContext(SocketContext)

    let isWaiting = false;

    // if (config?.PreChatSurvey?.disableChatboxOnBotTransferQueue) {
        let languageCheck = engagementParam?.language;
        if (languageCheck) {  
            if (languageCheck?.includes('ISTG')) {
                languageCheck = languageCheck.replace('ISTG', '');
            }
    
            console.log(languageCheck, 'languageCheck');
            let waitingSystemMsg = systemMessageCheck(languageCheck?.replace(/ /g,''))
            // console.log(waitingSystemMsg, 'waitingSystemMsgs');
    
            if (!isWaiting) {
                isWaiting = messages[messages.length -1]?.body?.elementText.text.includes(waitingSystemMsg) ? true : false;
            }
        }

    // }

    const _signOut = ()=>{
        
    }

    const callBBCardCall =async (data) =>{
        let result = await callBBCard(data);
    }

    useEffect(()=>{
        if(user.data) {
            dispatch(setPage('chat'));
            document.body.style.overflow = "hidden";
            window.scrollTo(0, 0);
            _defaultSendMessage();
            return ()=>{
                isMounted = false;
            } 
        }
    },[engagement.data])

    useEffect(()=>{
    if(Object.keys(engagementParam).length > 0) {
        
        callBBCardCall({...engagementParam, "bbc_id": user.data.bbc_id});
    }
    },[engagementParam])

    const handleClickOutside = (event) => {
        setIsEmojiShown(false);
    };
      
    useEffect(()=>{

        const handleButtonPressed = (evt , emojiPressed)=> {
            evt = evt || window.event;
            var isEscape = false;
            const isTextAreaFocused = document.activeElement.tagName === "TEXTAREA" && document.activeElement.classList.contains('chat-client-textarea')
            const isEmojiFocused = !!document.activeElement.closest(".emoji-mart")
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } 
            if (isEscape) {
                if(isEmojiShown && (isTextAreaFocused || isEmojiFocused)){
                    setIsEmojiShown(!isEmojiShown)
                }
                else {
                    _signOut();
                }
            };
        }
        //@ts-ignore
        document.onkeydown = handleButtonPressed;

    },[isEmojiShown])

    useEffect(()=>{
        if(scrollRef.current && isMounted){
            scrollRef.current.scrollToBottom()
        }
    },[messages])

    const restartChat = ()=>{
    setChatConnectivityStatus(WAITING_FOR_AGENT)
    _defaultSendMessage();
    }


    const onEmojiClick = (emoji)=>{
        let el = textarea.current
        const [start, end] = [el.selectionStart, el.selectionEnd];
        el.setRangeText(emoji.native, start, end,'end');
        setMsg(el.value);
        el.focus()
    }

    const _sendMessage = (e)=>{
        if(!msg.trim().length) return;
        e?.preventDefault();
        let elementText = {
            text:msg,
            textFormat:'PLAINTEXT'
        } 

        let body = {
            elementType: "text",
            elementText: elementText,
            payload: undefined
        }

        let message = {
            body: body,
            senderName: user.data.displayName,
            providerDialogId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderDialogId !== undefined) ? user.data.chProviderDialogId : user.data.providerDialogId) : user.data.providerDialogId,
            providerSenderId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderSenderId !== undefined) ? user.data.chProviderSenderId : user.data.providerSenderId) : user.data.providerSenderId,
            engagementParam: user.data.engagementParameters,
            customerIdentifiers: user.data.customerIdentifiers,
        }

        setMsg('')
        let s = socket.getInstance()
        console.log(engagement.data);
        s.emit("message",message,(res)=>{
            setIsEmojiShown(false)
            if(res.hasError){
            //   engagementExists(engagement.data?.engagementId)
            }
        })
    }

    const _defaultSendMessage = ()=>{
        let elementText = {
            text: mParam ? mParam : (config?.ChatBox?.HelloMessageText && config?.ChatBox?.HelloMessageText != "") ? config?.ChatBox?.HelloMessageText : "Hello",
            textFormat:'PLAINTEXT'
        } 

        let body = {
            elementType: "text",
            elementText: elementText,
            payload: undefined
        }

        let message = {
            body: body,
            senderName: user.data.displayName,
            providerDialogId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderDialogId !== undefined) ? user.data.chProviderDialogId : user.data.providerDialogId) : user.data.providerDialogId,
            providerSenderId: engagement.params.CustomerVerified == "true" ? ((user.data.chProviderSenderId !== undefined) ? user.data.chProviderSenderId : user.data.providerSenderId) : user.data.providerSenderId,
            engagementParam: user.data.engagementParameters,
            customerIdentifiers: user.data.customerIdentifiers,
        }
console.log(message);

        let s = socket.getInstance()
        s.emit("message",message,(res)=>{
            setIsEmojiShown(false)
            if(res.hasError){
            //   engagementExists(engagement.data?.engagementId)
            }
        })
    }

    const textareaaOnKeyDown = event => {
    if(event.shiftKey && event.key === "Enter"){
        event.preventDefault()
        const inputVal = `${msg} \n`
        setMsg(inputVal);
    }
    else if (event.key === "Enter" && msg.length && !event.shiftKey) {
        event.preventDefault()
        //@ts-ignore
        _sendMessage()
    } 
    }






    useEffect(()=>{


    // if there is agent or supervisor -> agent connected
    // if there is no agent or supervisor -> then make it participant disconnected
    // if there is no customer initiate request to check for the engagement if there is no engagement then make it participant disconnected
    const participantsTypes = participants.map(p=>p.participantType)
    let agentDispalyN = participants.map(item=> {
        if (item.participantType == "AGENT") {
        return item.displayName
        }
    })
    agentDispalyN = agentDispalyN.filter(e =>  e)
    setAgentDispalyName(agentDispalyN);

    if(participantsTypes.includes(AGENT) || participantsTypes.includes(SUPERVISOR)){
        let agentOrSupervisor = participants.filter(p=>p.participantType === AGENT || p.participantType === SUPERVISOR)
        setResponderType(agentOrSupervisor[agentOrSupervisor.length-1].participantType)
        setChatConnectivityStatus(PARTICIPANT_ADDED)
        isWaiting = false;
        setDisableChat("")
        return;

    } 

    if((!participantsTypes.includes(AGENT) || !participantsTypes.includes(SUPERVISOR)) && messages?.length > 0){
        setChatConnectivityStatus(PARTICIPANT_DISCONNECTED)
        // engagementExists(engagement.data?.engagementId)
    }
        if((!participantsTypes.includes(AGENT) || !participantsTypes.includes(SUPERVISOR) || !participantsTypes.includes(CUSTOMER) )&& messages?.length > 0) {
        // engagementExists(engagement.data?.engagementId)
    } 

    if(typeof config?.appApp !== 'undefined' && typeof config?.appApp.init_msg !== 'undefined' && config?.appApp.init_msg !== null) {
        setMsg(config?.appApp.init_msg)
        //@ts-ignore
        _sendMessage()
    }
    },[participants])

    useEffect(()=>{
    if(isSocketConnected && isBotConnected){
        setChatConnectivityStatus(SYSTEM_CONNECTED)
        setDisableChat("")
    }
    },[isBotConnected])

    useEffect(()=>{
        if (isWaiting) {
        setDisableChat("disabled");
        }
    },[isWaiting])


    const inputRef = useRef(null);

    const handleClick = () => {
    // 👇️ open file input box on click of another element
        inputRef.current.click();
    };

    let onScreenFlag = true;

    if (engagementParam.Brand === "ftv" || engagementParam.Brand === "istg-ftv") {
        onScreenFlag = false;
    }

    let notification = {
        title: "Wonderful!",
        message: "Configurable",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
        animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
        dismiss: {
            duration: 5000,
            onScreen: onScreenFlag
        }
    };

    const handleFileChange = event => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        }
        const allowedFileType = ['application/pdf', 'image/png', 'image/jpeg','image/jpg'];
        if (allowedFileType.indexOf(fileObj.type) == -1) {
            // @ts-ignore
            Store.addNotification({
            ...notification,
            title: config?.ChatBox.FileUploadFaileTitle,
            message: config?.ChatBox.FileTypeErrorMessage,
            type: "danger",
            });
            return;
            
        }

        if (fileObj.size > 4000000) {
            // @ts-ignore
            Store.addNotification({
            ...notification,
            title: config?.ChatBox.FileUploadFaileTitle,
            message: config?.ChatBox.FileSizeErrorMessage,
            type: "danger",
            });
            return;
        }


        const formData = new FormData();
        formData.append('image', fileObj);
        formData.append('providerDialogId', engagement.params.CustomerVerified == "true" ? ((user.data.chProviderDialogId !== undefined) ? user.data.chProviderDialogId : user.data.providerDialogId) : user.data.providerDialogId);
        formData.append('providerSenderId', engagement.params.CustomerVerified == "true" ? ((user.data.chProviderSenderId !== undefined) ? user.data.chProviderSenderId : user.data.providerSenderId) : user.data.providerSenderId);
        formData.append('engagementParam', JSON.stringify(user.data.engagementParameters));
        formData.append('customerIdentifiers', JSON.stringify(user.data.customerIdentifiers));
        //axios.post(config?.appApp.chatConnectorUrlV2 + '/image-upload', formData)
        axios.post(`${process.env.REACT_APP_CHATCON_URL}/image-upload`, formData)
        .then((response) => {
        // validationMessage = response.data;
            console.log(response.data);
            // @ts-ignore
            Store.addNotification({
            ...notification,
            title: config?.ChatBox.FileUploadSuccessTitle,
            message: config?.ChatBox.FileUploadSuccessMessage,
            type: "success",
        });
        })
        .catch((error) => {
        // @ts-ignore
        Store.addNotification({
            ...notification,
            title: config?.ChatBox.FileUploadFaileTitle,
            message: config?.ChatBox.FileUploadFaileMessage,
            type: "danger",
        });
            console.log(error);
        });
        console.log('fileObj is', fileObj);

        // 👇️ reset file input
        event.target.value = null;

        // 👇️ is now empty
        console.log(event.target.files);

        // 👇️ can still access file object here
        console.log(fileObj);
        console.log(fileObj.name);
    };


    function systemMessageCheck(lang) {

    switch (lang) {
        case 'EN':
        return 'Please stay online while we connect you to our Online Support Representative.';
        break;

        case 'IN':
        return 'Please stay online while we connect you to our Online Support Representative.';
        break;

        case 'HI':
        return 'Please stay online while we connect you to our Online Support Representative.';
        break;
        
        case 'TE':
        return 'Please stay online while we connect you to our Online Support Representative.';
        break;

        case 'KR':
        return '저희 사이트를 방문해주셔서 감사합니다! 상담원과 연결중이오니 잠시만 기다려주시기 바랍니다.';
        break;

        case 'ID':
        return 'Mohon tunggu, kami sambungkan Anda pada salah satu agen representatif kami.';
        break;

        case 'TH':
        return 'ขออภัย ขณะนี้เจ้าหน้าที่ให้บริการเต็มทุกคู่สาย รบกวนรอสักครู่';
        break;
        
        case 'CN':
        return '目前客服人员繁忙，关于给您造成长时间的等待我们深表歉意。请您耐心等待，客服人员将立即为您服务。';
        break;


        default:
        return 'Please stay online while we connect you to our Online Support Representative.';
        break;
    }
    };

    const Loader = (ccaas)=> {
        return <div className='loader'>
                    <div>
                    <BarLoader />
                    <p>{ ccaas.connecting }</p>
                    </div>
                </div>
        }

    const ChatCompInfo = ({appChatBox})=>{
        return <div className="announcement-wrapper-outer chat-comp-info-styled">
            <div className="announcement-wrapper">
                <div className="megaphone-icon-container">
                    <img className="megaphone" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAcCAMAAADcK/YTAAAAAXNSR0IB2cksfwAAATVQTFRFAAAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAArwAAvLFz/AAAAGd0Uk5TAAdCBGADzcZo/+MXygkb6/lDC+HlEOCu/X8M7zH1BSuTLQJ8NCwvtVOYabw6urj7CBEGOZwo7Q9AKbGDDg0z80bxISQd2rNQ1B/LbgEKo2VxVUwY5xQW3F2/XzBZkCLpeE8VtkUnVDucGa0AAAFiSURBVHicfZNrPwJBGMVPUhxJWUmFKJJLUiHXpBQhci2Xcuf7fwSzU7ttP2vPi51nz/PfObMzu4CJbH1ysPc7zLrtnnNAjoMccv2HDJNutRjx0GsO2QTCUVG4oYzRZzdBxv0C4QSgBIIITTL4F5maplQYMwHOItKJNSg6x47mgRi5gDgXe5GYX0O4JG6XuYIEV3uQJLtaiwIp0p4mtXZmfSNqp1Gbws1yy01mVMCxHRfmDnaNzJ5k9nNkSlQH+Y55aGQKQJh0FEmRetQx81B6wkrIlY9xwrKYpqKZpzgzMudA9QKXrAEh3bzCtZHxyZe58SjArW7eId0Tdi+hKuQmaKqjYWQeujv3qJtPqBmZSpdxBTTT2Z5ZXG3152arkutCL68qkH0rVk0+Ff20Y++JtHi6WLKAVC7S8pJFS+ZDrsr//4+gqimX3bJO+9ROwELugoSSllBMRRpf1mnfwZ+6mf8Lh74qbc4Ham4AAAAASUVORK5CYII=" alt=""/>
                </div>
                <div id="announcement" className="text-container">
                    <p id="innerElement">{ appChatBox.AnnouncementText }</p>
                </div>
            </div>
        </div>
    }


    const ChatConnectivity = ({chatConnectivityStatus , responderType , isSocketConnected, isBotConnected, ccaas, appChatBox, agentDispalyName})=>{
        if(!isSocketConnected){
            return <div className={'chat-connectivity responder-disconnected'}>
            <>
                <MoonLoader color={'#000'} size={12} />
                <p>{ ccaas.reconnecting }</p>
            </>
            </div>
        }

        return  <div className={`chat-connectivity
                    ${chatConnectivityStatus == PARTICIPANT_ADDED?'agent-connected':''}
                    ${chatConnectivityStatus == WAITING_FOR_AGENT?'wating-for-agent':''}
                    ${chatConnectivityStatus == PARTICIPANT_DISCONNECTED?'responder-disconnected':''}
                    ${chatConnectivityStatus == SYSTEM_CONNECTED?'system-connected':''}
            `}>
            {
                (chatConnectivityStatus == WAITING_FOR_AGENT)?
                <>
                <MoonLoader color={'#000'} size={12} />
                <p>{ config.ChatLoader.WaitingForAgentText}</p>
                </>:null
            }
            {
                (chatConnectivityStatus == SYSTEM_CONNECTED) ?
                <>
                <BiSupport />
                <p style={{textTransform:'capitalize'}}> { config.ChatLoader.AgentConnectedText}</p>
                </>:null
            }
            {
                (chatConnectivityStatus == PARTICIPANT_ADDED) ?
                <>
                <BiSupport />
                <p style={{textTransform:'capitalize'}}> { config.ChatBox.YouAreChattingWith + " " + agentDispalyName }</p>
                </>:null
            }
            {
                (chatConnectivityStatus == PARTICIPANT_DISCONNECTED ) ?
                <>
                <GrFormClose />
                <p>{ config.ChatLoader.SessionEndText }</p>
                </>:null
            }
                
        </div>
    }

    return (
    user.signIn.loading || !user.data?.customerToken?<Loader ccaas={config}/>:
    <div className="chat"  style={{height:'100%'}}>
        <ReactNotifications />
        {config.Announcement?<ChatCompInfo appChatBox={config.ChatBox}/>:null}
        <ChatConnectivity responderType={responderType} isSocketConnected={isSocketConnected} isBotConnected={isBotConnected} chatConnectivityStatus={chatConnectivityStatus} ccaas={config} appChatBox={config.ChatBox} agentDispalyName={agentDispalyName} />
        
            <Scrollbars role="chat" aria-live="polite" renderThumbHorizontal={()=><span></span>} ref={scrollRef} className={'messages-container'}>
            {messages?.map((item, index) => {
                // Check if any of the previous 3 messages were rich media
                let isPrevRichMedia = false;
                
                // Look back up to 3 messages
                for (let i = 1; i <= 3; i++) {
                    if (index - i >= 0) {
                        const prevMsg = messages[index - i];
                        if (prevMsg && 
                            prevMsg.senderParticipantType === "SYSTEM" && 
                            prevMsg.body.richMediaPayload) {
                            isPrevRichMedia = true;
                            break;
                        }
                    }
                }
                
                return <Message 
                         message={item} 
                         key={item.messageId} 
                         previousMessageType={isPrevRichMedia ? "RICH_MEDIA" : "NORMAL"}
                       />;
            })}
            </Scrollbars>
            {isEmojiShown && (chatConnectivityStatus !=PARTICIPANT_DISCONNECTED)?
                <div ref={pickerRef} style={{
                    position:"absolute",
                    bottom: "0",
                    right: "0",
                    marginBottom: "65px",
                    marginRight: "15px",
                }}>
                    <Picker  
                        showPreview={false}
                        data={data}
                        native
                        onEmojiSelect={onEmojiClick}
                    />
                </div>:null} 

        <div className='chat-box-container'> 
        {
            (chatConnectivityStatus !=PARTICIPANT_DISCONNECTED && isSocketConnected)?
            <>

                <textarea  maxLength={2500} aria-label='type your message here'   disabled ={ disableChat} onKeyDown={textareaaOnKeyDown} value={msg}  ref={textarea}  onChange={(e)=>setMsg(e.target.value)} >{msg}</textarea>
                <div className='actions-container'>
                { config.ChatBox.EnableAttachment && disableChat !== "disabled" ?
                    <div>
                    <input
                    accept="image/jpeg, image/png, image/jpg, application/pdf"
                    style={{display: 'none'}}
                    ref={inputRef}
                    type="file"
                    onChange={handleFileChange}
                    />

                    <button onClick={handleClick}><FiPaperclip aria-label='Attach image files only' title={config.Tooltips.AttachmentTooltip} size="25"/></button>
                </div>: null
                }
                <button  onClick={()=>setIsEmojiShown(!isEmojiShown)}>
                    <BsEmojiSmile aria-label='show emojis picker' title={config.Tooltips.EmojisPickerTooltip} size="25" />
                </button> 
                
                <button onClick={_sendMessage}>
                    <FiSend aria-label='send message' title= {config.Tooltips.SendMessageTooltip} size="25" />
                </button>
                </div>
            </> : isSocketConnected ? 
            <div className='start-new-session'>
                <button onClick={()=>restartChat()}>
                { config.ReconnectChat.StartNewSessionLabel }
                </button>
            </div>:null
        }
        </div>
    </div>
    );
}

export default Chat;
